// Home.tsx
import React, { useEffect, useState } from "react";
import Slider from "../components/HomeSlider/Slider";
import slides from "../demo/slides.json";
import './../styles/Home.scss'
import BrandGrid from "../components/BrandGrid/BrandGrid";
import { HomeSlider } from "../types/HomeSlider";
import { HomeBrandBanner } from "../types/HomeBrandBanner";
import { executeFetch } from "../helper/Api";
import { useLoadingStore } from "../store/loadingStore";
import useUserStore from "../store/userStore";
import useToastStore from "../store/toastStore";
import { LoginRequest } from "../types/User";

export default function Home(){
    const [sliders,setSliders] = useState<HomeSlider[]>([]);
    const [banners,setBanners] = useState<HomeBrandBanner[]>([])
    const {setLoading} = useLoadingStore();
  const { login,user } = useUserStore();
  const {showToast} = useToastStore();
    const fetchHomeSliders =async () => {
      setLoading(true);
      //fetch home sliders
      const homeSlidersResp = await executeFetch<HomeSlider[]>('Home/GetHomeSliders',{admin:true});
      if(homeSlidersResp.error){
         console.error(homeSlidersResp.error.message)
      }else{
        const sortedSliders = homeSlidersResp.data.sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
        setSliders(sortedSliders);

      }
      setLoading(false);
    }

    const fetchHomeBrandBanners=async () => {
      setLoading(true);
      //fetch home sliders
      const homeBannersResp = await executeFetch<HomeSlider[]>('Home/GetHomeBrandBanners',{admin:true});
      if(homeBannersResp.error){
         console.error(homeBannersResp.error.message)
      }else{
        const sortedBanners = homeBannersResp.data.sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
        setBanners(sortedBanners);
  
      }
      setLoading(false);
    }

    useEffect(()=>{
      const fetchHomeInfo = async () => {
          await fetchHomeSliders();
          await fetchHomeBrandBanners();
         if(!user){
             const loginReq  : LoginRequest = {
                 username: 'test@mail.com',
                 password: '123'
             }
               await login(loginReq,showToast);
         }
      }
      fetchHomeInfo();
    },[])


  return (
  <div className="homePage page">
    <div className="sliderWrapper">
      <Slider slides={sliders}/>
    </div>
    <BrandGrid banners={banners}/>
  </div>
  ) ;
};


